<template>
  <div class="page-content-wrapper user-list-page" v-check-permission="'list-users'">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card m-b-20">
            <div class="card-block">

              <h4 class="mt-0 header-title">Usuarios</h4>
              <p class="text-muted m-b-30 font-14">Desde aqui podras administrar los usuarios que acceden al sistema.</p>


              <div class="table-rep-plugin">
                <div class="btn-toolbar">
                  <div class="btn-group dropdown-btn-group pull-right">

                  </div>
                  <div class="clearfix"></div>
                </div>

                <div>
                  <div class="row">
                    <div class="col-md-2 mb-3">
                      <input type="number" @keyup.enter="search()" class="form-control" v-model="params.dni" placeholder="DNI" aria-controls="datatable">
                    </div>
                    <div class="col-md-2 mb-3">
                      <input type="email" @keyup.enter="search()" class="form-control" v-model="params.email" placeholder="Email" aria-controls="datatable">
                    </div>
                    <div class="col-md-2 mb-3">
                      <select class="custom-select form-control" v-model="params.role">
                        <option :value="null">Rol</option>
                        <option v-for="role in roles" v-bind:value="role._id">
                          {{ role.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-2 mb-3">
                      <button class="btn btn-primary bootstrap-touchspin-up" @click="search()" type="button"><i class="fa fa-search"></i></button>
                      <button class="btn btn-primary" @click="clearFilters()">Limpiar</button>
                    </div>
                    <div class="col-md-4 mb-3">
                      <button class="btn btn-primary pull-right" @click="getAll()"><i class="fa fa-refresh" aria-hidden="true"></i> Mostrar todos</button>
                      <router-link v-check-permission="'edit-users'" to="/edit-user" class="btn btn-info waves-effect waves-light pull-right mr-3">Agregar nuevo</router-link>
                    </div>
                  </div>
                </div>
              </div>



              <div class="row pull-right mb-2">
                  <div class="col-md-12">
                    <small><b>({{ users.total }} registros)</b></small>
                  </div>
                </div>

                <div class="table-responsive b-0" data-pattern="priority-columns">
                  <table class="table table-striped">
                    <thead>
                    <tr>
                      <th>Usuario</th>
                      <th>Alias</th>
                      <th>DNI</th>
                      <th>Nombre completo</th>
                      <th>Rol</th>
                      <th>Estado</th>
                      <th>Verificación</th>
                      <th>Creado el</th>
                      <th class="col-icon" v-check-permission="'edit-users'"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="users.docs" v-for="user in users.docs" :key="user._id">
                      <td><b>{{ user.email }}</b></td>
                      <td>{{ user.displayName}}</td>
                      <td><b v-if="user.file">{{ user.file.personalData.dni }}</b><span class="badge badge-default" v-else>Sin datos</span></td>
                      <td><b v-if="user.file">{{ user.file.personalData.lastName }} {{ user.file.personalData.firstName }}</b><span class="badge badge-default" v-else>Sin datos</span></b></td>
                      <td>
                        <span class="badge badge-info" v-if="user.admin">Admin</span>
                        <span class="badge badge-warning" v-if="user.role && user.role.name && user.role.isDefault">{{ user.role.name }}</span>
                        <span class="badge badge-danger" v-if="user.role && user.role.name && !user.role.isDefault">{{ user.role.name }}</span>
                      </td>
                      <td><span class="badge badge-success" v-if="user.active">Activo</span><span class="badge badge-primary" v-if="!user.active">Inactivo</span> </td>
                      <td><span class="badge badge-success" v-if="user.verifiedAccount">Cuenta verificada</span><span class="badge badge-primary" v-if="!user.verifiedAccount">Cuenta sin verificar</span></td>
                      <td>{{ user.createdAt | moment("DD/MM/YYYY") }}</td>
                      <td v-check-permission="'edit-users'">
                        <router-link :to="{ name: 'edit-user', params: { id: user._id }}" class="text-info mr-3"><i class="fa fa-pencil"></i></router-link>
                        <a href="javascript:void(0);" class="text-primary"  @click="setUser(user)"  data-toggle="modal" data-target="#deleteConfirm"><i class="fa fa-minus-circle"></i></a>
                      </td>
                    </tr>
                    <tr v-if="users.docs && users.docs.length === 0">
                      <td colspan="9">No se encontraron registros.</td>
                    </tr>
                    </tbody>
                  </table>

                  <pagination v-bind:current-page="params.page" v-bind:total-pages="users.pages">
                  </pagination>

                </div>

            </div>
          </div>
        </div> <!-- end col -->
      </div> <!-- end row -->

    </div><!-- container -->

    <div id="deleteConfirm" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" v-check-permission="'edit-users'">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title mt-0">Confirmar eliminación</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>¿Realmente desea eliminar el registro?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-primary delete-btn" @click="deleteUser(user._id)">Confirmar</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->

  </div>
</template>


<script>
  import config from '../data/config'
  import pagination from '../components/Pagination.vue'

  export default {
    name: 'user-list',

    components: {
      pagination
    },

    created () {
      this.getAllRoles();
      this.getAllUsers();

      this.$on('pageChanged:pagination', val => {
        this.params.page = val;
        this.getAllUsers();
      })
    },


    data () {
      return {
        params: {
          limit: config.pagination.limit,
          page: 1,
          dni: null,
          email: null,
          role: null
        }
      }
    },


    computed: {

      users: function () {
        return this.$store.getters.getAllUsers
      },

      user: function () {
        return this.$store.getters.getUser
      },

      roles: function () {
        return this.$store.getters.getAllRoles
      }

    },


    methods: {


      getAllUsers () {
        this.$loader.loading();

        this.$store.dispatch('getAllUsers', { params : this.params })
          .then((response) => {
            this.$loader.close();
          })
          .catch((response) => {
            this.$loader.close();
            this.$message.error({text: response.message});
          })
      },



      deleteUser (id) {
        $('.delete-btn').attr('disabled', true)

        this.$store.dispatch('deleteUser', { id : id })
          .then((response) => {
            $('.delete-btn').attr('disabled', false)
            $('#deleteConfirm').modal('hide');
          })
          .catch((response) => {
            $('.delete-btn').attr('disabled', false)
            $('#deleteConfirm').modal('hide');
            this.$message.error({text: response.message});
          })

        return true
      },



      setUser (user) {
        this.$store.dispatch('setUser', { user : user })
      },




      getAll: function () {
        this.clearFilters();
        this.getAllUsers();
      },



      search: function () {
        if(this.params.dni || this.params.email || this.params.role) {
          this.params.page = 1;
          this.getAllUsers();
        }
      },


      clearFilters() {
        this.params.dni = null;
        this.params.email = null;
        this.params.role = null;
        this.params.page = 1;
      },

      getAllRoles () {
        this.$store.dispatch('getAllRoles')
      }

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/screens/UserListScreen.vue